import { getRequestTransportErrorMessage } from '#/utils/requestError';

export function getSignReceiptApiErrorMessage(error, fallback = '操作失敗，請稍後再試') {
  const transportMessage = getRequestTransportErrorMessage(error);
  if (transportMessage) {
    return transportMessage;
  }

  const data = error?.response?.data;
  const code = data?.code;
  const status = error?.response?.status;

  if (status === 404 || code === 'SIGN_RECEIPT_NOT_FOUND') {
    return data?.message || '找不到簽收單';
  }
  if (code === 'RESOURCE_VERSION_CONFLICT') {
    return data?.message || '資料已被他人修改，請重新載入後再試';
  }
  if (code === 'UPDATED_AT_REQUIRED') {
    return data?.message || '缺少更新時間，請重新載入後再試';
  }
  if (code === 'SIGN_RECEIPT_NO_DUPLICATED') {
    return data?.message || '簽收單號已存在，請改用其他單號';
  }
  if (code === 'SIGN_RECEIPT_REPAIR_ITEM_NOT_LATEST') {
    return data?.message || '所選維修品項不是該 SN 最新報告所屬品項';
  }
  if (code === 'SIGN_RECEIPT_REPAIR_ITEM_NOT_ELIGIBLE') {
    return data?.message || '維修品項報告須為已完成或拒修，且符合簽收資格';
  }
  if (code === 'SIGN_RECEIPT_REPAIR_ITEM_LOCKED') {
    return data?.message || '維修品項已被其他簽收單鎖定';
  }
  if (code === 'SIGN_RECEIPT_REPAIR_ITEM_CUSTOMER_MISMATCH') {
    return data?.message || '所選維修品項的客戶與簽收單客戶不同';
  }
  if (code === 'CRM_CUSTOMER_NOT_ACTIVE') {
    return data?.message || '客戶已停用，請改選啟用中的客戶';
  }
  if (code === 'SIGN_RECEIPT_UPDATE_NOT_ALLOWED') {
    return data?.message || '僅草稿可編輯';
  }
  if (code === 'SIGN_RECEIPT_ESTABLISH_NOT_ALLOWED') {
    return data?.message || '僅草稿可成立';
  }
  if (code === 'SIGN_RECEIPT_COMPLETE_NOT_ALLOWED') {
    return data?.message || '僅已成立單據可完成';
  }
  if (code === 'SIGN_RECEIPT_CANCEL_NOT_ALLOWED') {
    return data?.message || '此狀態不可取消';
  }
  if (code === 'SIGN_RECEIPT_EXCEL_EXPORT_NOT_ALLOWED') {
    return data?.message || '僅已成立或已完成的簽收單可下載 Excel';
  }
  if (code === 'SIGN_RECEIPT_DATE_REQUIRED') {
    return data?.message || '請填寫預計送交日';
  }

  return data?.message || fallback;
}

export function isSignReceiptVersionConflict(error) {
  return error?.response?.data?.code === 'RESOURCE_VERSION_CONFLICT';
}

export function isSignReceiptNoDuplicated(error) {
  return error?.response?.data?.code === 'SIGN_RECEIPT_NO_DUPLICATED';
}
